import { PageTitle, Button } from '@ui-components/neo.tax';

import { PageLayout, useCurrentCompanyId } from '@neo.tax/shared';

import { TaxFormTable } from '../tax-form-table';
import { useSubmitTaxDocuments } from './hooks';

export const ExportTaxLayout = (): React.ReactElement => {
  const { disabled, submitTaxDocuments } = useSubmitTaxDocuments();
  const companyId = useCurrentCompanyId();

  const handleSubmit = async (): Promise<void> => {
    await submitTaxDocuments(companyId);
  };
  return (
    <PageLayout
      title={<PageTitle>Downloads</PageTitle>}
      subtitle="Download R&D tax credit form and writeup."
      trailingContent={
        <Button size="base" variant="primary" rounded="regular" disabled={disabled} onClick={handleSubmit}>
          Submit
        </Button>
      }
    >
      <TaxFormTable />
    </PageLayout>
  );
};
